import React, { PropsWithChildren } from "react";
//#region types
import { ExpansionPanelProps } from "models/propTypes/panelsPropsTypes";
//#endregion
//#region components
import { Accordion, AccordionSummary, AccordionDetails, Grid, Divider } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { ErrorBoundary } from "components/error";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const SimpleExpansionPanel: React.FC<PropsWithChildren<ExpansionPanelProps>> = (props) => {
  return (
    <React.Fragment>
      <Grid item container className={clsx(cssExports.simpleExpansionPanelContainer, props.className)}>
        <Accordion
          className={cssExports.simpleExpansionPanel}
          defaultExpanded={props.defaultExpanded ?? false}
          expanded={props.expanded}
          onChange={props.onChange}
        >
          <AccordionSummary
            classes={{
              root: cssExports.simpleExpansionPanelSummary,
              content: cssExports.simpleExpansionPanelSummaryContent,
              expandIconWrapper: cssExports.expansionPanelIcon,
            }}
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            className={props.borderless ? cssExports.expansionPanelBorderLess : ""}
          >
            <Grid container direction="row" flexWrap="nowrap">
              <Grid item className={cssExports.expansionPanelTitle}>
                {props.title}
              </Grid>
              {props.titleExtraText !== undefined && (
                <Grid item className={cssExports.expansionPanelTitleSubText}>
                  <Grid container direction="row" gap={2} alignItems="center">
                    <Grid item className={cssExports.verticalDividerContainer}>
                      <Divider className={cssExports.verticalDividerGrey} />
                    </Grid>
                    <Grid item className={cssExports.expandableHeaderExtraText}>
                      {props.titleExtraText}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </AccordionSummary>
          <AccordionDetails
            classes={{
              root: cssExports.expansionPanelDetails,
            }}
          >
            <ErrorBoundary>
              <Grid item container direction="column">
                <Grid item container className={cssExports.expansionPanelSummaryText}>
                  {props.summary}
                </Grid>
                {props.children}
              </Grid>
            </ErrorBoundary>
          </AccordionDetails>
        </Accordion>
      </Grid>
    </React.Fragment>
  );
};

export default SimpleExpansionPanel;
